import { Routes } from '@angular/router';

export const collectionRankRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./collection-rank.page').then((m) => m.CollectionRankPage),
  },
];
